
export enum GroundPositionState {
  READY = 'READY',
  MARKED_TO_REPLACE_RFID = 'MARKED_TO_REPLACE_RFID',
  NO_STATE = 'NO_STATE',
  BLOCKED = 'BLOCKED',
  LAYOUTING = 'LAYOUTING',
  MARKED_TO_REPLACE_QR_CODE = 'MARKED_TO_REPLACE_QR_CODE'
}

export enum GroundPositionStateOptions {
  READY = 'READY',
  BLOCK = 'BLOCK',
  MARK_TO_REPLACE_QR_CODE = 'MARK_TO_REPLACE_QR_CODE'
}

export enum GroundPositionType {
  DOCK = "DOCK",
  IN = "IN",
  EXIT = "EXIT",
  STREET = "STREET",
  STOCK = "STOCK",
  PICKING = "PICKING",
  QUALITY_CONTROL = "QUALITY_CONTROL",
  DAMAGES = "DAMAGES",
  DIVERGENT_STOCK = "DIVERGENT_STOCK",
  PROVISION = "PROVISION",
  EXPEDITION = "EXPEDITION",
  PICKING_MISCELLANEOUS = "PICKING_MISCELLANEOUS",
  PIGEONHOLE = "PIGEONHOLE"
}